import React from 'react';

const TEMP_COLORS = {
  Hot: { stroke: '#f97316', glow: 'rgba(249, 115, 22, 0.4)', text: 'text-orange-500' },
  Warm: { stroke: '#f59e0b', glow: 'rgba(245, 158, 11, 0.35)', text: 'text-amber-500' },
  Cold: { stroke: '#3b82f6', glow: 'rgba(59, 130, 246, 0.35)', text: 'text-blue-500' },
};

// Radial progress ring around a lead's initials. Animates stroke-dashoffset on mount.
const LeadScoreRing = ({ score = 0, name = '?', temperature = 'Cold', size = 56, showScore = true, animate = true }) => {
  const safeScore = Math.max(0, Math.min(100, Math.round(score)));
  const stroke = 4;
  const radius = (size - stroke) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (safeScore / 100) * circumference;
  const cfg = TEMP_COLORS[temperature] || TEMP_COLORS.Cold;
  const initials = (name || '?').split(/\s+/).map((w) => w[0]).filter(Boolean).slice(0, 2).join('').toUpperCase();

  return (
    <div className="relative inline-flex items-center justify-center" style={{ width: size, height: size }}>
      <svg width={size} height={size} className="absolute inset-0 -rotate-90" style={{ filter: `drop-shadow(0 0 6px ${cfg.glow})` }}>
        <circle
          cx={size / 2} cy={size / 2} r={radius}
          fill="none" stroke="currentColor"
          className="text-slate-200 dark:text-slate-800"
          strokeWidth={stroke}
        />
        <circle
          cx={size / 2} cy={size / 2} r={radius}
          fill="none" stroke={cfg.stroke}
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={animate ? offset : offset}
          style={{
            transition: animate ? 'stroke-dashoffset 900ms cubic-bezier(0.22, 1, 0.36, 1)' : 'none',
          }}
        />
      </svg>
      <div className="relative flex items-center justify-center w-full h-full">
        <span className="font-display font-bold text-slate-700 dark:text-slate-200" style={{ fontSize: size * 0.32 }}>
          {showScore ? safeScore : initials}
        </span>
      </div>
    </div>
  );
};

export default LeadScoreRing;
